<template>
    <ModalOverlay :show="showCookieModal" @bounce="bounce()">
        <div class="fixed inset-0 lg:flex lg:items-center justify-center z-50 p-4 overflow-y-auto">
            <div class="p-4 bg-white max-w-screen-md rounded-lg mx-auto" :class="{'animate-bounce': bounceEffect}">
                <div class="col-12">
                    <b class="my-2 block">Required cookies</b>
                    <p>These are necessary for our website to operate. They're set automatically and can't be switched off in our system. Whilst you can set your browser to block them, our site won't then work for you.</p>
                    <hr class="block mt-2">
                </div>
                <form @submit.prevent="onSubmit" method="post" ref="cookieForm">
                    <div>
                        <b class="my-2 block">Performance cookies</b>
                        <label for="performance" class="cursor-pointer">
                            <input class="form-check-input cursor-pointer" type="checkbox" id="performance" name="performance" v-model="fields.performance" />
                            <p class="inline pl-3">We use these to see how our site is being used, so we can improve the experience for all customers. The data is aggregated across all visitors, so is anonymous.</p>
                        </label>
                        <hr class="block mt-2">
                    </div>
                    <div>
                        <b class="my-2 block">Advertising cookies</b>
                        <label for="advertising" class="cursor-pointer">
                            <input class="form-check-input cursor-pointer" type="checkbox" id="advertising" name="advertising" v-model="fields.advertising" />
                            <p class="inline pl-3">We use these to tailor advertising to your interests - both on our site and other sites you visit. If you disable them, you'll still see adverts, they just won't be tailored to you.</p>
                        </label>
                        <hr class="block mt-2">
                    </div>
                    <div>
                        <b class="my-2 block">Functional cookies</b>
                        <label for="functional" class="cursor-pointer">
                            <input class="form-check-input cursor-pointer" type="checkbox" id="functional" name="functional" v-model="fields.functional" />
                            <p class="inline pl-3">We use these to improve our sites functionality and personalisation. They may be set by us or by third party providers whose services we use on our site.</p>
                        </label>
                        <hr class="block mt-2">
                    </div>
                    <div class="modal-footer py-2 text-right">
                        <button type="button" class="px-5 py-2 h-11 text-white rounded-full font-bold bg-gradient-to-tr from-green-100 to-green-200 hover:to-green-100" id="close" @click="$emit('toggleModal')">Close</button>
                        <button type="submit" class="ml-3 px-5 py-2 h-11 text-white rounded-full font-bold bg-primary hover:bg-purple-300" @click="$emit('closeModal')">Save changes</button>
                    </div>
                </form>
            </div>
        </div>
    </ModalOverlay>
</template>

<script>
import {useGtag} from "vue-gtag-next";
import ModalOverlay from "@/Components/Modals/ModalOverlay";

export default {
    props: ['advertisingCookie', 'performanceCookie', 'functionalCookie', 'cookiePage', 'showCookieModal'],
    emits: ['toggleModal', 'closeModal'],
    data() {
        return {
            fields: {
                "performance": this.performanceCookie,
                "advertising": this.advertisingCookie,
                "functional": this.functionalCookie,
            },
            errors: {},
            bounceEffect: false,
        }
    },
    components: { ModalOverlay },
    methods: {
        async getUpdatedCookies() {
            let vm = this;
            axios.get(route('cookies.get')).then(response => {
                vm.fields = response.data;
            });
        },
        onSubmit() {
            this.errors = {};
            axios.post(route('manage-cookie-settings'), this.fields).then(response => {
                const {query} = useGtag();

                if(this.fields.advertising == true) {
                    query('consent', 'update', {
                        'ad_storage': 'granted',
                        'ad_user_data': 'granted',
                        'ad_personalization': 'granted'
                    });
                }
                else {
                    query('consent', 'update', {
                        'ad_storage': 'denied',
                        'ad_user_data': 'denied',
                        'ad_personalization': 'denied'
                    });
                }

                if(this.fields.performance == true) {
                    query('consent', 'update', {
                        'analytics_storage': 'granted',
                    });
                }
                else {
                    query('consent', 'update', {
                        'analytics_storage': 'denied',
                    });
                }
            }).catch(error => {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                }
            });

            this.updatedShowCookieModal = false;
        },
        bounce() {
            this.bounceEffect = true;
            setTimeout(() => this.bounceEffect = false, 2000);
        }
    },
    watch: {
        showCookieModal(value) {
            if (value) {
                this.getUpdatedCookies();
            }
        }
    }
}
</script>
